import React from 'react'
import PropTypes from 'prop-types'
import Selected from 'src/assets/img/house/btn_check.svg'

const AvatarItem = ({ avatar, isSelected, onSelect }) => {
  const handleClick = () => {
    onSelect(avatar.id)
  }

  return (
    <label className="relative h-14 w-14 xs:h-20 xs:w-20 flex items-center justify-center cursor-pointer border-2 border-house-blue rounded-[10px] bg-cream bg-pat02">
      <input
        type="radio"
        name="avatar"
        value={avatar.id}
        checked={isSelected}
        onChange={handleClick}
        className="hidden"
      />
      <img
        src={avatar.img}
        alt={avatar.label}
        className="h-10 w-10 xs:h-16 xs:w-16 object-cover hover:scale-105 transition-transform"
        loading="lazy"
      />
      {isSelected && (
        <span className="absolute w-4 h-4 xs:w-5 xs:h-5 bottom-1 right-0.5">
          <img src={Selected} alt="selected" className="object-cover" />
        </span>
      )}
    </label>
  )
}

AvatarItem.propTypes = {
  avatar: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    img: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default AvatarItem
